import { apiClient } from "../config";

async function editDataPortal(id: any, body: any): Promise<any> {
  const res = await apiClient.put(`/admin/data-portals/${id}`, body);
  return res.data;
}

export default editDataPortal;
